import PropTypes from 'prop-types';
import React, { Children, useEffect, useState } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';
import { getDashboardLayout } from 'services/dashboardService';

/* WidgetGrid component
* This component renders a grid layout for widgets.
* It uses the react-grid-layout library to create a responsive grid layout. */

const ResponsiveGridLayout = WidthProvider(Responsive);

/* ResizableGridItem component
* It uses the Resizable component from react-resizable to allow resizing of the grid item. */
const ResizableGridItem = ({ children, ...rest }) => (
  <div {...rest} className="grid-item">
    <Resizable
      minConstraints={[800, 800]}
      width={rest.width}
      height={rest.height}
      onResize={rest.onResize}
      resizeHandles={rest.resizeHandles}
      className="p-0 m-0"
    >
      {children}
    </Resizable>
  </div>
);

export default function WidgetGrid(props) {
  const { canEdit, children } = props;
  const [layout, setLayout] = useState([]);
  const [childGrid, setChildGrid] = useState([]);

  // Create a default layout if the dashboard does not have one yet
  const generateDefaultLayout = () => {
    var l = [];
    var x = 0;
    var y = 0;
    for (var i = 0; i < 25; i++) {
      var c = String.fromCharCode(65 + i);
      l.push({ i: c, x: x, y: y, w: 2, h: 1 });
      x += 2;
    }
    return l;
  };

  // Build grid for each child element
  const generateChildGrid = () => {
    var grid = [];
    Children.forEach(children, (child, index) => {
      var c = String.fromCharCode(65 + index);
      var elem = (
        <div
          key={c}
          style={{
            width: '100%',
            height: '100%',
            minHeight: '150px'
          }}
        >
          <ResizableGridItem
            key={c}
            static={!canEdit}
            isResizable={canEdit}
            resizeHandles={canEdit ? ['se'] : []}
            style={{
              width: '100%',
              height: '100%',
              minHeight: '150px'
            }}
          >
            {child}
          </ResizableGridItem>
        </div>
      );
      grid.push(elem);
    });
    return grid;
  };

  useEffect(() => {
    if (layout.length == 0) {
      loadLayout();
      setChildGrid(generateChildGrid());
    }
  }, []);

  // Load the layout from the server
  // If the layout is not available, generate a default layout
  const loadLayout = () => {
    getDashboardLayout(props.dashboardId)
      .then(result => {
        setLayout(result.data);

        if (canEdit == false) {
          for (let i = 0; i < result.data.length; i++) {
            result.data[i].isResizable = false;
            result.data[i].isDraggable = false;
          }
        }
        setLayout(result.data);
      })
      .catch(err => {
        setLayout(generateDefaultLayout());
        console.error('Failed to load layout', err);
      });
  };
  return (
    <div>
      <ResponsiveGridLayout
        className="layout"
        layouts={{ lg: layout }}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 4, sm: 2, xs: 2, xxs: 2 }}
        rowHeight={150}
        width={1200}
        onLayoutChange={props.onLayoutChange}
        isDraggable={canEdit}
        isResizable={canEdit}
      >
        {childGrid}
      </ResponsiveGridLayout>
    </div>
  );
}

WidgetGrid.propTypes = {
  children: PropTypes.array,
  canEdit: PropTypes.bool,
  dashboardId: PropTypes.number,
  onLayoutChange: PropTypes.func
};

ResizableGridItem.propTypes = {
  children: PropTypes.array
};
